import React from 'react';
import './Hero.scss';
import HeroImage from '../../assets/HeroImage.png';
import HeroMobileImage from '../../assets/HeroMobileImage.png';
import AppleImage from '../../assets/AppleImage.png';
import PlayStoreImage from '../../assets/PlayStoreImage.png';
import EncryptionIcon from '../../assets/EncryptionIcon.png';

export default function Hero() {
  return (
    <div className='hero-container'>
      <div className='left-section'>
        <div className='heading-container'>
          <h1>One App Endless</h1>
          <h1>Possibilities</h1>
        </div>
        <div className='description-container'>
          <p>The Only PDF App You'll Ever Need – Secure, Convert,</p>
          <p> and Edit with Ease!</p>
        </div>
        <div className='store-container'>
          <div className='apple-store-container'>
            <div className='apple-image-container'>
              <img src={AppleImage} alt="apple store" />
            </div>
            <div className='store-detailsContainer'>
              <p>Download on</p>
              <h2>Apple store</h2>
            </div>
          </div>

          <div className='google-playStore-container'>
            <div className='playstore-image-container'>
              <img src={PlayStoreImage} alt="playstore" />
            </div>
            <div className='store-detailsContainer'>
              <p>Get it on</p>
              <h2>Playstore</h2>
            </div>
          </div>
        </div>

        <div className='encryption-hero-container'>
          <h3>Protected by <span>AES & RSA Encryption over SSL</span></h3>
          <div className='encryption-icon'>
            <img src={EncryptionIcon} alt="encryption" />
          </div>
        </div>
      </div>
      <div className='right-section'>
        <img src={HeroImage} alt="hero" />
      </div>

      <div className='heading-mobile-Container'>
        <h1>One App Endless possibilities</h1>
        <p>The Only PDF App You'll Ever Need – Secure, Convert, and Edit with Ease!</p>
      </div>
      <div className='hero-mobile-image-container'>
        <img src={HeroMobileImage} alt="hero mobile" />
      </div>
      <div className='store-mobile-container'>
        <div className='apple-store-container'>
          <div className='apple-image-container'>
            <img src={AppleImage} alt="apple store" />
          </div>
          <div className='store-detailsContainer'>
            <p>Download on</p>
            <h2>Apple store</h2>
          </div>
        </div>

        <div className='google-playStore-container'>
          <div className='playstore-image-container'>
            <img src={PlayStoreImage} alt="playstore" />
          </div>
          <div className='store-detailsContainer'>
            <p>Get it on</p>
            <h2>Playstore</h2>
          </div>
        </div>

        <div className='encryption-hero-mobile-container'>
          <h3>Protected by <span>AES & RSA Encryption over SSL</span></h3>
          <div className='encryption-icon'>
            <img src={EncryptionIcon} alt="encryption" />
          </div>
        </div>
      </div>
    </div>
  )
}
